/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationVariables = Types.Exact<{
  input: Types.ApplyRequirementItemActionsInput;
}>;


export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation = { applyRequirementItemActions: { __typename: 'ApplyRequirementItemActionsResult', requirement: { __typename: 'Requirement', id: string } } };


export const RequirementItemCompletionWizardModal_ApplyQuoteItemActionsDocument = gql`
    mutation RequirementItemCompletionWizardModal_applyQuoteItemActions($input: ApplyRequirementItemActionsInput!) {
  applyRequirementItemActions(input: $input) {
    requirement {
      id
    }
  }
}
    `;
export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationFn = Apollo.MutationFunction<RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation, RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationVariables>;

/**
 * __useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation__
 *
 * To run a mutation, you first call `useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requirementItemCompletionWizardModalApplyQuoteItemActionsMutation, { data, loading, error }] = useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation(baseOptions?: Apollo.MutationHookOptions<RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation, RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation, RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationVariables>(RequirementItemCompletionWizardModal_ApplyQuoteItemActionsDocument, options);
      }
export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationHookResult = ReturnType<typeof useRequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation>;
export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationResult = Apollo.MutationResult<RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation>;
export type RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationOptions = Apollo.BaseMutationOptions<RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutation, RequirementItemCompletionWizardModal_ApplyQuoteItemActionsMutationVariables>;